/* The Pet World — interactions (vanilla, no libraries) */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Reveal on scroll ---------- */
  function initReveal() {
    var els = document.querySelectorAll('.tp-reveal:not(.tp-visible)');
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window)) { els.forEach(function (el) { el.classList.add('tp-visible'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('tp-visible'); io.unobserve(e.target); } });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- Free shipping bar: rotating messages ---------- */
  function initShipbar() {
    document.querySelectorAll('[data-tp-shipbar]').forEach(function (bar) {
      if (bar.dataset.ready) return; bar.dataset.ready = '1';
      var msgs = bar.querySelectorAll('.tp-shipbar__msg');
      if (msgs.length < 2) { if (msgs[0]) msgs[0].classList.add('is-active'); return; }
      var i = 0, speed = (parseInt(bar.dataset.speed, 10) || 4) * 1000;
      msgs[0].classList.add('is-active');
      setInterval(function () {
        var cur = msgs[i]; i = (i + 1) % msgs.length; var next = msgs[i];
        cur.classList.remove('is-active'); cur.classList.add('is-out');
        next.classList.remove('is-out'); next.classList.add('is-active');
        setTimeout(function () { cur.classList.remove('is-out'); }, 650);
      }, speed);
    });
  }

  /* ---------- Estimated delivery dates (business days) ---------- */
  function addBusinessDays(d, n) {
    var r = new Date(d.getTime());
    while (n > 0) { r.setDate(r.getDate() + 1); var w = r.getDay(); if (w !== 0 && w !== 6) n--; }
    return r;
  }
  function fmt(d) {
    try { return d.toLocaleDateString(window.tpDateLocale || 'en-US', { weekday: 'short', month: 'short', day: 'numeric' }); }
    catch (e) { return d.toDateString(); }
  }
  function initDates() {
    var now = new Date();
    document.querySelectorAll('[data-tp-date]').forEach(function (el) {
      var min = parseInt(el.dataset.min, 10) || 0, max = parseInt(el.dataset.max, 10) || min;
      var a = addBusinessDays(now, min), b = addBusinessDays(now, max);
      el.textContent = (min === max) ? fmt(a) : fmt(a) + ' – ' + fmt(b);
    });
  }

  /* ---------- Product gallery (swipe + dots + thumbs) ---------- */
  function initGallery() {
    document.querySelectorAll('[data-tp-gallery]').forEach(function (g) {
      if (g.dataset.ready) return; g.dataset.ready = '1';
      var main = g.querySelector('.tp-gallery__main');
      var slides = g.querySelectorAll('.tp-gallery__slide');
      var dots = g.querySelectorAll('.tp-gallery__dot');
      var thumbs = g.querySelectorAll('.tp-gallery__thumb');
      var count = g.querySelector('[data-tp-count]');
      if (!main || !slides.length) return;
      function setActive(i) {
        dots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); });
        thumbs.forEach(function (t, k) { t.classList.toggle('is-active', k === i); });
        if (count) count.textContent = (i + 1) + ' / ' + slides.length;
      }
      function go(i) { main.scrollTo({ left: slides[i].offsetLeft - main.offsetLeft, behavior: reduce ? 'auto' : 'smooth' }); setActive(i); }
      var t;
      main.addEventListener('scroll', function () {
        clearTimeout(t);
        t = setTimeout(function () { var i = Math.round(main.scrollLeft / main.clientWidth); setActive(Math.max(0, Math.min(slides.length - 1, i))); }, 60);
      }, { passive: true });
      dots.forEach(function (d, k) { d.addEventListener('click', function () { go(k); }); });
      thumbs.forEach(function (th, k) { th.addEventListener('click', function () { go(k); }); });
      g.goToMedia = function (id) { slides.forEach(function (s, k) { if (s.dataset.mediaId === String(id)) go(k); }); };
      setActive(0);
    });
  }

  /* ---------- Quantity stepper ---------- */
  function initQty() {
    document.querySelectorAll('[data-tp-qty]').forEach(function (q) {
      if (q.dataset.ready) return; q.dataset.ready = '1';
      var input = q.querySelector('input');
      q.querySelectorAll('button').forEach(function (b) {
        b.addEventListener('click', function () {
          var v = parseInt(input.value, 10) || 1;
          v = b.dataset.dir === 'up' ? v + 1 : Math.max(1, v - 1);
          input.value = v;
        });
      });
    });
  }

  /* ---------- Bundle offer (sets the quantity) ---------- */
  function initOffer() {
    document.querySelectorAll('[data-tp-offer]').forEach(function (box) {
      if (box.dataset.ready) return; box.dataset.ready = '1';
      var form = box.closest('form');
      var input = form && form.querySelector('[data-tp-qty] input');
      if (!input) return;
      function sync() {
        var r = box.querySelector('input[type=radio]:checked');
        if (r) input.value = r.value;
      }
      box.addEventListener('change', sync);
      sync();
    });
  }

  /* ---------- Variant picker ---------- */
  function money(cents, format) {
    var v = (cents / 100).toFixed(2);
    var f = format || '${{amount}}';
    return f.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, k) {
      if (k === 'amount_no_decimals') return Math.round(cents / 100).toString();
      if (k === 'amount_with_comma_separator') return v.replace('.', ',');
      return v;
    });
  }
  function initVariants() {
    document.querySelectorAll('[data-tp-product]').forEach(function (root) {
      if (root.dataset.ready) return; root.dataset.ready = '1';
      var dataEl = root.querySelector('[data-tp-variants]');
      if (!dataEl) return;
      var variants = JSON.parse(dataEl.textContent);
      var fmtStr = root.dataset.moneyFormat;
      var idInputs = document.querySelectorAll('[data-tp-variant-id="' + root.dataset.productId + '"]');
      root.addEventListener('change', function (e) {
        if (!e.target.matches('[data-tp-option]')) return;
        var chosen = [];
        root.querySelectorAll('[data-tp-option-group]').forEach(function (grp) {
          var c = grp.querySelector('input:checked'); chosen.push(c ? c.value : null);
        });
        var v = variants.find(function (x) { return x.options.every(function (o, k) { return o === chosen[k]; }); });
        if (!v) return;
        idInputs.forEach(function (i) { i.value = v.id; });
        root.querySelectorAll('[data-tp-price]').forEach(function (p) { p.textContent = money(v.price, fmtStr); });
        root.querySelectorAll('[data-tp-compare]').forEach(function (p) {
          if (v.compare_at_price && v.compare_at_price > v.price) { p.textContent = money(v.compare_at_price, fmtStr); p.hidden = false; } else { p.hidden = true; }
        });
        document.querySelectorAll('[data-tp-add]').forEach(function (b) {
          b.disabled = !v.available;
          var label = b.querySelector('[data-tp-add-label]');
          if (label) label.textContent = v.available ? b.dataset.addText : b.dataset.soldText;
        });
        if (v.featured_media) { var g = document.querySelector('[data-tp-gallery]'); if (g && g.goToMedia) g.goToMedia(v.featured_media.id); }
        var url = new URL(window.location.href); url.searchParams.set('variant', v.id); window.history.replaceState({}, '', url.toString());
      });
    });
  }

  /* ---------- AJAX add to cart (opens Dawn cart drawer) ---------- */
  function initCartForms() {
    document.querySelectorAll('form[data-tp-cart]').forEach(function (form) {
      if (form.dataset.ready) return; form.dataset.ready = '1';
      form.addEventListener('submit', function (e) {
        var drawer = document.querySelector('cart-drawer');
        if (!drawer || typeof drawer.renderContents !== 'function') return; // fallback: normal submit to /cart
        e.preventDefault();
        var btn = form.querySelector('[type="submit"]');
        var err = form.querySelector('.tp-buy__error');
        if (btn) btn.classList.add('is-loading');
        var fd = new FormData(form);
        fd.append('sections', 'cart-drawer,cart-icon-bubble');
        fd.append('sections_url', window.location.pathname);
        fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
          method: 'POST', headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' }, body: fd
        }).then(function (r) { return r.json(); }).then(function (res) {
          if (res.status) { if (err) { err.textContent = res.description || res.message; err.classList.add('is-visible'); } return; }
          if (err) err.classList.remove('is-visible');
          drawer.classList.remove('is-empty');
          if (typeof drawer.setActiveElement === 'function') drawer.setActiveElement(btn || document.activeElement);
          drawer.renderContents(res);
        }).catch(function () { form.submit(); })
          .finally(function () { if (btn) btn.classList.remove('is-loading'); });
      });
    });
  }

  /* ---------- Sticky add-to-cart bar ---------- */
  function initSticky() {
    var bar = document.querySelector('[data-tp-sticky]');
    var target = document.querySelector('[data-tp-sticky-target]');
    if (!bar || !target || bar.dataset.ready) return;
    bar.dataset.ready = '1';
    if (bar.parentElement !== document.body) document.body.appendChild(bar);
    document.body.classList.add('tp-has-sticky');
    var ticking = false;
    function update() { ticking = false; bar.classList.toggle('is-visible', target.getBoundingClientRect().bottom < 0); }
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(update); } }, { passive: true });
    update();
    var btn = bar.querySelector('[data-tp-sticky-btn]');
    if (btn) btn.addEventListener('click', function () {
      var form = document.getElementById(btn.dataset.form);
      if (form && form.requestSubmit) form.requestSubmit(); else if (form) form.submit();
    });
  }

  function initAll() { initReveal(); initShipbar(); initDates(); initGallery(); initQty(); initOffer(); initVariants(); initCartForms(); initSticky(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll); else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();
